module.exports = {
          srcSet: __webpack_public_path__ + "07b6941a21f11a29bcb30d97a74b31d5-153.png"+" 153w",
          images:[ {path: __webpack_public_path__ + "07b6941a21f11a29bcb30d97a74b31d5-153.png",width: 153,height: 97}],
          src: __webpack_public_path__ + "07b6941a21f11a29bcb30d97a74b31d5-153.png",
          toString:function(){return __webpack_public_path__ + "07b6941a21f11a29bcb30d97a74b31d5-153.png"},
          
          width: 153,
          height: 97
        }